import BasePage from '@/found/components/table_page';
import Form from '../../components/process_approve/approve.vue';
import Print from '../dealt/print';
import request from '../../../../utils/request';

export default {
  extends: BasePage,
  components: {
    Form,
  },
  data() {
    return {};
  },
  created() {
    this.getConfigList('process_center_process_instance_main_table');
  },
  methods: {
    modalClick({ val, row }) {
      const { code } = val;
      if (code === 'view') {
        this.modalConfig.title = '查看';
        this.modalConfig.type = 'EmptyDrawer';

        this.formConfig = {
          code,
          row,
        };
        this.openModal();
      } else if (code === 'print') {
        request.post('/mdm/mdmdictdata/list', { dictTypeCode: 'print_process_key' }).then((res) => {
          if (res.success) {
            for (const item of res.result) {
              if (item.process_key.indexOf(row.processKey) >= 0) {
                new Print({
                  id: row.businessId,
                  logId: row.processInstanceId,
                  type: item.dictCode,
                }).print();
                break;
              }
            }
          }
        });
      }
    },
  },
};
